<section class="families-table">
	<section class="row body-row text-16" *ngFor="let family of families; let i = index">
		<!-- Family name and number of portfolios -->
		<div *ngIf="family?.portfolios?.length > 0" class="col-24 col-md-24 col-sm-24 collapsible collapsible-content" (click)="onToggleCollapsible(i)">
			<div class="row">
				<section class="cell text-16-bold padding-15" [ngClass]="{ 'order-2 col-17 col-md-17 col-sm-17': arrowLeft, 'col-16 col-md-16 col-sm-16': !arrowLeft }">
					{{ getFamilyName(family) }}
				</section>
				<section class="col-6 col-md-6 col-sm-6 cell text-14 text-align-center padding-15" [ngClass]="{ 'order-3': arrowLeft }">
					{{ family.portfolios.length }} models
				</section>
				<section
					class="cell collapse-action padding-horizontal-15 padding-top-20 padding-bottom-10"
					[ngClass]="{ 'order-1 col-1 col-md-1 col-sm-1': arrowLeft, 'col-2 col-md-2 col-sm-2': !arrowLeft }"
				>
					<i [ngClass]="getArrowClass(i)"></i>
				</section>
			</div>
		</div>
		<!-- Family's portfolios -->
		<div class="col-24 col-md-24 col-sm-24">
			<div class="row">
				<div ngClass="collapsible-content padding-horizontal-10" *ngIf="contentsMap.get(i)">
					<span class="family-description text-14" [dcrHTMLKey]="(family.familyCode | uppercase) + '_DESCRIPTION_DCR'"></span>
					<mp-model-list-table
						[models]="family.portfolios"
						[tableMode]="mode"
						[showCheckboxes]="showCheckboxes"
						[allowMultiple]="allowMultiple"
						[analyticsModelType]="family.subType + ' Model'"
						[(selectedModelPortfolios)]="selectedModelPortfolios"
						(closeEnclosingModal)="closeModal()"
						[maxLimit]="maxLimit"
						[useDasPortfolioId]="useDasPortfolioId"
						(onModelSelected)="onModelPortfolioSelected()"
					></mp-model-list-table>
				</div>
			</div>
		</div>
	</section>
	<section class="row body-row no-items" *ngIf="families.length === 0" dcrHTMLKey="BROWSE_ALL_NO_FAMILIES_MESSAGE">
		There are no model portfolio families matching the filters provided.
	</section>
</section>
